/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Experience_Stopped_Ago_LongInputs */

const en_us2_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginners progress every session; intermediates every week. Overestimating means stalls, underestimating means boredom.`)
};

const pt_br2_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciantes progridem a cada sessão; intermediários a cada semana. Superestimar trava; subestimar entedia.`)
};

const es_419_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los principiantes progresan cada sesión; los intermedios, cada semana. Sobrestimar te estanca; subestimar te aburre.`)
};

const pt_pt2_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os principiantes progridem a cada sessão; os intermédios a cada semana. Sobrestimar trava; subestimar aborrece.`)
};

const fr_fr2_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les débutants progressent à chaque séance, les intermédiaires chaque semaine. Surestimer mène à la stagnation, sous-estimer à l'ennui.`)
};

const de_de2_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger steigern sich jede Einheit, Fortgeschrittene jede Woche. Überschätzen heißt Stillstand, Unterschätzen heißt Langeweile.`)
};

const it_it2_intake_why_experience_stopped_ago_long = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I principianti progrediscono a ogni sessione, gli intermedi ogni settimana. Sopravvalutarsi porta a stalli, sottovalutarsi alla noia.`)
};

/**
* | output |
* | --- |
* | "Beginners progress every session; intermediates every week. Overestimating means stalls, underestimating means boredom." |
*
* @param {Intake_Why_Experience_Stopped_Ago_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_experience_stopped_ago_long = /** @type {((inputs?: Intake_Why_Experience_Stopped_Ago_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Experience_Stopped_Ago_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_experience_stopped_ago_long(inputs)
	if (locale === "es-419") return es_419_intake_why_experience_stopped_ago_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_experience_stopped_ago_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_experience_stopped_ago_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_experience_stopped_ago_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_experience_stopped_ago_long(inputs)
	return en_us2_intake_why_experience_stopped_ago_long(inputs)
});
export { intake_why_experience_stopped_ago_long as "intake.why.experience_stopped_ago.long" }